/**
 * CompetitionFooter - Results Mode Footer Component
 *
 * Simplified footer for results mode.
 * Only shows "View Live Leaderboard" button.
 * Quick Pick, Clear, and Submit buttons are now in StickyActionBar and PickProgressBar.
 */

import React from 'react';
import { Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface CompetitionFooterProps {
  onLeaderboardClick: () => void;
}

export const CompetitionFooter: React.FC<CompetitionFooterProps> = ({ onLeaderboardClick }) => {
  const { t } = useTranslation();

  return (
    <div className="p-4 bg-game-card border-t border-border/30">
      <Button
        data-test-id="view-leaderboard-btn"
        variant="outline"
        className="w-full"
        onClick={onLeaderboardClick}
      >
        <Eye className="w-4 h-4 mr-2" />
        {t('game.actions.viewLeaderboard')}
      </Button>
    </div>
  );
};
